import React, { useEffect, useState } from 'react';
import './sidenav.components.css';
import logo from '../../assets/images/SCSLogo.svg'
import dashIcon from '../../assets/images/ic_dashboard_24px.svg'
import logoutIcon from '../../assets/images/ic_power_settings_new_24px.svg'
import feedbackIcon from '../../assets/images/feedback-icon.svg'
import { logout } from '../../services/auth.api';



interface SubItem {
  name: string;
  link: string;
}

interface Item {
  name: string;
  icon: string;
  link: string;
  active?: boolean;
  hasSub?: boolean;
  subItems?: SubItem[];
}

interface NavGroup {
  label: string;
  items: Item[];
}

const Sidebar = () => {
  // State to manage which submenus are open
  const [openSubMenus, setOpenSubMenus] = useState<{ [key: number]: boolean }>({});
  const [activeItem, setActiveItem] = useState<string | null>(null); // State to manage active items
  const [activeGroup, setActiveGroup] = useState<string | null>(null); // State to manage active items

  const [footerMenuVisible, setFooterMenuVisible] = useState(false);
  const toggleFooterMenu = () => {
    setFooterMenuVisible(!footerMenuVisible);
  };
  const toggleSubMenu = (index: number) => {
    setOpenSubMenus((prev) => ({ ...prev, [index]: !prev[index] })); // Toggle the current submenu
  };

  const handleItemClick = (itemName: string) => {
    setActiveItem(itemName); // Set the active item
  };

  const navGroups: NavGroup[] = [
    {
      label: 'Number 2',
      items: [
        { name: 'Number 21', icon: 'bi bi-arrow-right-short', link: '/' },
        { name: 'Number 22', icon: 'vaadin-line-h', link: '/' },
        { name: 'Number 23', icon: 'ri-calendar-line', link: '/' },
      ],
    },
    {
      label: 'Number 3',
      items: [
        { name: 'Number 31', icon: 'ri-folder-2-line', link: '/' },
      ],
    }
  ];

  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [skinMode, setSkinMode] = useState<string | null>(localStorage.getItem('skin-mode'));
  const [sidebarSkin, setSidebarSkin] = useState<string | null>(localStorage.getItem('sidebar-skin'));


  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
    document.body.classList.toggle('sidebar-hide', !sidebarVisible);
  };


  const pathToNavItemMap: { [key: string]: { itemName: string, groupIndex: number } } = {
    '/number21': { itemName: 'Number 21', groupIndex: 0 },
    '/number31': { itemName: 'Number 31', groupIndex: 1 },
  };
  const currentPath = window.location.pathname;
  useEffect(() => {

    console.log(currentPath);

  if (currentPath === "/dashboard") {
      const agegroup = currentPath.replace(/^\//, '') || '';
      let activeGroupLabel = '';
      for (const group of navGroups) {
        if (group.label.toLowerCase().includes(agegroup)) {
          activeGroupLabel = group.label; 
          break; 
        }
      }
      console.log(activeGroupLabel);
      setActiveGroup(activeGroupLabel);
      if (pathToNavItemMap[currentPath]) {
        const { itemName, groupIndex } = pathToNavItemMap[currentPath];
        console.log(itemName)
        setActiveItem(itemName);
        setOpenSubMenus((prev) => ({ ...prev, [groupIndex]: true }));
      }

    }
    else {
      const agegroup = currentPath.split("/").pop() || '';
      let activeGroupLabel = '';
      for (const group of navGroups) {
        if (group.label.includes(agegroup)) {
          activeGroupLabel = group.label; 
          break; 
        }
      }
      console.log(activeGroupLabel);
      setActiveGroup(activeGroupLabel);
      if (pathToNavItemMap[currentPath]) {
        const { itemName, groupIndex } = pathToNavItemMap[currentPath];
        console.log(itemName)
        setActiveItem(itemName);
        setOpenSubMenus((prev) => ({ ...prev, [groupIndex]: true }));
      }
    }
  }, []);


  return (
    <>

      <div className={`sidebar ${sidebarVisible ? 'sidebar-hide' : 'sidebar-show '}${footerMenuVisible ? 'footer-menu-show' : ''}`}>
        <div className="sidebar-header">
          <a href="../" className="sidebar-logo">
          <img src={logo} alt="" />
          </a>
          <span id="menuSidebar" className="menu-link" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
          </span>
        </div>
        <div id="sidebarMenu" className="sidebar-body">
          <a className={`nav-d-label ${currentPath === '/dashboard' ? 'active' : ''}`} href="/dashboard"><img src={dashIcon} alt="dashicon"/> Dashboard </a>
        </div>
        <div className="sidebar-footer">
        <div id="sidebarMenu" className="sidebar-body">
        <a className="nav-label" href="https://scsglobalservices.atlassian.net/servicedesk/customer/portal/13" target='_blank'> <img src={feedbackIcon}/> Feedback </a>
        <div className="nav-label" onClick={logout}  style={{ cursor: 'pointer' }}><img src={logoutIcon}/>  Log out </div>

        </div>
        </div>
      </div>
    </>

  );
};

export default Sidebar;
